import React from "react"
import Drop from "./Drop.jsx"
export default function Item ({item, setShow, setTabla}){
   
    const {title, drop, icon} = item
  
    return (
        <div className='dropend position-relative z-1 px-4 py-2 w-100 border-bottom border-dark-subtle'>
            <a className='text-dark text-uppercase text-capitalize shadow-none dropdown-toggle bg-transparent fs-6 w-100'
                data-bs-auto-close="outside" 
                type="button" 
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <i className={icon} />
                <span className="fw-bold texto-item text-uppercase">{title}</span>
            </a>
            <Drop item={drop} setTabla={setTabla} setShow={setShow}/>
        </div>
    )
}